import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className='w-full' src="https://cdn.dribbble.com/users/381530/screenshots/3949858/404.gif" alt="" />
        </div>
    );
};

export default NotFound;